import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { asyncConnect } from "redux-connect";

import EventDescription from "./components/EventDescription";
import * as labelsActions from "../../../components/labels/actions";
import * as searchEventActions from "../../BrowseAndNavigate/SearchEvent/actions";
import VozCliente from "../../../components/VozCliente";

import AppEvents from "../../App/AppEvents";
import ApplyCSS from "../../../components/ApplyCSS";
import commonUtil from "./../../../utils/commonUtil";
import serverClientUtil from "./../../../utils/serverClientUtil";
import { createTag } from "../../../utils/googleTagManagerUtils";
import UserEventsCardList from "../MarketingContentSection/components/UserEventsCardList";

const { isLablesLoaded, loadLables } = labelsActions;
const { cleanSearchByUserDetails, isSearchEventLoaded } = searchEventActions;
const channel = commonUtil.getChannel();
const constChannel = commonUtil.getClientConstForChannel();

const applicationRoutes = commonUtil.getApplicationRoutes();

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (isSearchEventLoaded(getState())) {
        return dispatch(cleanSearchByUserDetails());
        // return dispatch({ type: 'CLEAN_STATE_WARNING' });
      }
      return undefined;
    },
  },
])
@connect(
  (store) => ({
    store : store,
    user: store.user.data,
    labels: store.labels.data,
    eventDetails: store.eventDetail.data,
    filterProductSearchResultStore:
      store.searchResult.filterProductSearchResult,
  }),
  { ...labelsActions }
)
class MultipleEvents extends Component {
  constructor() {
    super();
    this.wapBackButtonEvent = null;
    this.prevStepFunc = this.prevStepFunc.bind(this);
  }

  componentWillUnmount() {
    if (channel === constChannel.WAP) {
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
  }

  componentDidMount() {
    if (channel === constChannel.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(
        AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED
      );
      AppEvents.publish(this.wapBackButtonEvent, [this.prevStepFunc]);
    }
    commonUtil.addTransition();
    const btnSearchEvent = document.querySelector(
      "div.middleFooter__buttons .btnPrimary"
    );
    if (btnSearchEvent !== null) {
      btnSearchEvent.addEventListener("click", () => {
        browserHistory.push(applicationRoutes.searchEvent);
      });
    }
  }

  prevStepFunc = () => {
    window.location.href = serverClientUtil.getLPFullURL();
  };

  handleLoginWithAuth0 = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = "https:" + url + "/login";
    const redirectBackUrl = `${window.location.origin}/crearevento/seleccioneeltipodemesa`;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`
    );
  };

  onCreateMesaDeRegalosClick = () => {
    const { user = {} } = this.props;
    const result = user?.result || {};

    if (result.firstName) {
      createTag({
        event: "mesa_regalos",
        phase: "Banner Mesa de regalos con eventos",
        selection: "Crear mesa de regalos",
        seccion: "Mesa de Regalos",
      });
      location.href =
        serverClientUtil.getMultiSiteURL(serverClientUtil.getBrand()) +
        "/crearevento/seleccioneeltipodemesa";
      return;
    }

    this.handleLoginWithAuth0();
  };

  render() {
    const { labels = {}, eventDetails = {}, user } = this.props;
    const result = user?.result || {};
    const { firstName = "", myEventDetail } = result;
    const { eventList = [] } = eventDetails || {};

    const eventDetaillength = eventList.length;
    const pageName = "multipleEvents";
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <VozCliente page="mesas" />
        <div
          className="contentBox"
          id={eventDetaillength > 2 ? "whichMesa" : "moreThanOne"}
        >
          <div className="row">
            <div className="col-xs-12">
              <div className="registerTitles">
                <h2
                  className={
                    channel === "web" ? "titleModule" : "subtitleSection"
                  }
                >
                  {" "}
                  {firstName}, ¿
                  {commonUtil.getLabel(
                    labels.eventList,
                    "eventList.gift.message"
                  )}
                  ?
                </h2>
                <h2 className="subtitleModule">
                  Tenemos {eventDetaillength}{" "}
                  {commonUtil.getLabel(
                    labels.eventList,
                    "eventList.associated.events"
                  )}
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            {channel === "web" ? (
              <div
                className={
                  eventDetaillength > 2 ? "eventSelection" : "whichIcons"
                }
              >
                <div className="col-xs-12">
                  {eventList &&
                    eventList.map((data, index) => (
                      <React.Fragment key={index}>
                        <EventDescription
                          key={index}
                          eventId={data.eventId}
                          eventName={data.eventName}
                          eventStatus={data.eventStatus}
                          eventType={data.eventType}
                          eventDetaillength={eventDetaillength}
                        />
                        {(index + 1) % 3 === 0 ? (
                          <div className="clearfix" />
                        ) : null}
                      </React.Fragment>
                    ))}
                </div>
              </div>
            ) : (
              <div
                className={eventDetaillength > 2 ? "" : "col-xs-12 whichIcons"}
              >
                {eventList &&
                  eventList.map((data, index) => (
                    <React.Fragment key={index}>
                      <EventDescription
                        eventId={data.eventId}
                        eventName={data.eventName}
                        eventStatus={data.eventStatus}
                        eventType={data.eventType}
                        eventDetaillength={eventDetaillength}
                      />
                      {(index + 1) % 2 === 0 ? (
                        <div className="clearfix" />
                      ) : null}
                    </React.Fragment>
                  ))}
              </div>
            )}
          </div>

          <div className="middleFooter">
            <p>Crea o busca una mesa de regalos</p>
            <div className="middleFooter__buttons">
              <button className="btnPrimary" type="button" aria-hidden="false">
                Buscar una Mesa de Regalos
              </button>
              <button
                className="btnSecondary"
                type="button"
                aria-hidden="false"
                onClick={this.onCreateMesaDeRegalosClick}
              >
                Crear Mesa de Regalos
              </button>
            </div>
          </div>
          {myEventDetail.length > 0 && (
            <UserEventsCardList eventsList={myEventDetail}  state={this.props?.store} />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default MultipleEvents;
